import {Link, useLocation} from 'react-router-dom';
import {createCx} from '@utils/cx';
import styles from './Header.module.less';
import {useProjectStore} from '@/store/projectStore';
import {useTracking} from '@/services/tracking/context';
import {TrackEvents} from '@/services/tracking/constant';

const cx = createCx(styles);

interface HeaderProps {
    className?: string;
}

const Header: React.FC<HeaderProps> = ({className}) => {
    const {pathname} = useLocation();
    const projectName = useProjectStore((state) => state.projectInfo?.projectName);
    const {sendClickLog} = useTracking();

    return (
        <header className={cx('header', className)}>
            <Link
                to="/"
                aria-label="返回首页"
                onClick={() => {
                    sendClickLog({
                        value: TrackEvents.PLATFORM_LOGO,
                    });
                }}
            >
                <img
                    src="https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/headerLogo.png"
                    className={styles.logo}
                    alt="logo"
                />
            </Link>
            {pathname.startsWith('/workspace') && projectName && (
                <>
                    <span className={styles.divider} />
                    <div className={styles.title}>{projectName}</div>
                </>
            )}
        </header>
    );
};

export default Header;
